import React, { useState } from 'react';
import { Modal } from 'antd';
import { withApollo } from 'react-apollo';
import { bool, func, object } from 'prop-types';
import { Text, FlexContainer, Row, Icon, Button, IconContainer } from '../../common';
import { UPDATE_MAIL_REPORT } from '../../../queries';

export const ModalDelete = ({ visible, toggleModal, infoToModalDelete, client, setDrawerVisible }) => {
    const { email, itemKey } = infoToModalDelete;
    const [loading, setLoading] = useState(false);

    return (
        <Modal
            closable={false}
            visible={visible}
            footer={null}
            destroyOnClose
        >
            <FlexContainer align='center' direction='column'>
                <IconContainer color='#f38630'>
                    <Icon name='trash' color='#ffffff' size={46.8} />
                </IconContainer>
                <FlexContainer mY={30} direction='column' align='center'>
                    <Row justify='center'>
                        <Text text={`Eliminarás notificación de ${email},\u00a0`} />
                    </Row>
                    <Row>
                        <Text centered text='¿Estás seguro?' />
                    </Row>
                </FlexContainer>
                <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                    <Button
                        link
                        text='btn.action.cancel'
                        style={{ width: '100px' }}
                        onClick={() => toggleModal()}
                    />
                    <Button
                        disabled={loading}
                        loading={loading}
                        text='btn.action.confirm'
                        style={{ width: '100px' }}
                        onClick={() => {
                            setLoading(true);

                            client.mutate({
                                mutation: UPDATE_MAIL_REPORT,
                                variables: {
                                    input: {
                                        jobName: itemKey,
                                        email: email,
                                        "enabled": false
                                    }
                                },
                                refetchQueries: ['getMailReport']
                            }).then(() => {
                                setLoading(false);
                                toggleModal();
                                setDrawerVisible(false);
                            });
                        }}
                    />
                </FlexContainer>
            </FlexContainer>
        </Modal>
    );
};

ModalDelete.propTypes = {
    visible: bool,
    toggleModal: func,
    infoToModalDelete: object,
    client: object,
    setDrawerVisible: func
};

export default withApollo(ModalDelete);
